// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import accordion from "@steiner/XDL/PreStyle/accordion";
import breadcrumbs from "@steiner/XDL/PreStyle/breadcrumbs";
import breakpoints from "@steiner/XDL/PreStyle/breakpoints";
import button from "@steiner/XDL/PreStyle/button";
import checkbox from "@steiner/XDL/PreStyle/checkbox";
import colors from "@steiner/XDL/PreStyle/colors";
import content from "@steiner/XDL/PreStyle/content";
import dataTable from "@steiner/XDL/PreStyle/dataTable";
import datePicker from "@steiner/XDL/PreStyle/datePicker";
import drawer from "@steiner/XDL/PreStyle/drawer";
import dynamicDropdown from "@steiner/XDL/PreStyle/dynamicDropdown";
import focus from "@steiner/XDL/PreStyle/focus";
import formField from "@steiner/XDL/PreStyle/formField";
import globalStyle from "@steiner/XDL/PreStyle/globalStyle";
import header from "@steiner/XDL/PreStyle/header";
import lazyImage from "@steiner/XDL/PreStyle/lazyImage";
import link from "@steiner/XDL/PreStyle/link";
import loadingSpinner from "@steiner/XDL/PreStyle/loadingSpinner";
import menu from "@steiner/XDL/PreStyle/menu";
import modal from "@steiner/XDL/PreStyle/modal";
import orderedList from "@steiner/XDL/PreStyle/orderedList";
import overflowMenu from "@steiner/XDL/PreStyle/overflowMenu";
import pagination from "@steiner/XDL/PreStyle/pagination";
import panelMenu from "@steiner/XDL/PreStyle/panelMenu";
import radio from "@steiner/XDL/PreStyle/radio";
import select from "@steiner/XDL/PreStyle/select";
import swatch from "@steiner/XDL/PreStyle/swatch";
import tab from "@steiner/XDL/PreStyle/tab";
import tag from "@steiner/XDL/PreStyle/tag";
import textArea from "@steiner/XDL/PreStyle/textArea";
import textField from "@steiner/XDL/PreStyle/textField";
import toast from "@steiner/XDL/PreStyle/toast";
import tooltip from "@steiner/XDL/PreStyle/tooltip";
import typography from "@steiner/XDL/PreStyle/typography";
import unorderedList from "@steiner/XDL/PreStyle/unorderedList";
import zIndex from "@steiner/XDL/PreStyle/zIndex";
import { xBaseTheme } from "@steiner/XDL/types";

export default {
    breakpoints,
    colors,
    focus,
    // shadows,
    // transition,
    globalStyle,
    typography,
    zIndex,
    accordion,
    breadcrumbs,
    button,
    checkbox,
    // clickable,
    content,
    dataTable,
    datePicker,
    drawer,
    dynamicDropdown,
    // fileUpload,
    // footer,
    header,
    formField,
    // fieldSet,
    // icon,
    // layoutTable,
    // layoutGroup,
    // layoutCell,
    link,
    // lists,
    lazyImage,
    // loadingOverlay,
    loadingSpinner,
    unorderedList,
    // listItem,
    orderedList,
    menu,
    modal,
    overflowMenu,
    pagination,
    panelMenu,
    radio,
    select,
    // signIn,
    swatch,
    tab,
    tag,
    // tagsField,
    textField,
    // tokenExFrame,
    textArea,
    toast,
    tooltip,
} as xBaseTheme;
